import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { useGateModal } from '../hooks/useGateModal';
const Navbar = () => {
  const navigate = useNavigate();
  const { openGate } = useGateModal();

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 z-50 bg-tc-bg/80 backdrop-blur-md border-b border-tc-border"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        {/* Logo */}
        <div
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => navigate('/')}
          data-testid="navbar-logo"
        >
          <img
            src="/tca-logo.png"
            alt="Traders Council Asia"
            className="h-10 w-auto"
          />
          <div className="hidden sm:block">
            <span className="font-heading font-bold text-white text-sm leading-tight block">
              Traders Council Asia
            </span>
            <span className="text-xs text-tc-text-secondary leading-tight block">
              Indonesia
            </span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex items-center gap-3">
          <Button
            onClick={openGate}
            className="bg-tc-primary hover:bg-tc-primary-hover text-white font-bold rounded-full px-5"
            data-testid="navbar-telegram-btn"
          >
            <span className="hidden sm:inline">MULAI QUIZ</span>
            <span className="sm:hidden">QUIZ</span>
          </Button>
        </nav>
      </div>
    </motion.header>
  );
};

export default Navbar;
